module.exports = __webpack_public_path__ + "static/media/network.4b8ec5cf.png";